import { FC, Fragment, createPortal } from "preact/compat";
import { Transition } from "@headlessui/react";
import { usePortalTarget } from "~/hooks";
import { PopupProps } from "./interfaces";

const Popup: FC<PopupProps> = ({ show, coords, children }) => {
    const target = usePortalTarget("marquee-popup");

    if (!target.value) {
        return null;
    }

    return createPortal(
        <Transition
            show={show.value}
            as={Fragment}
            enter="transition duration-200 ease-out"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="transition duration-100 ease-in"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
        >
            <div
                style={{ ...coords.value }}
                className="fixed z-[60] pointer-events-none bg-white/90 backdrop-blur-sm border border-gray-300 p-2 text-xs rounded-lg max-w-[calc(100vw-24px)]"
            >
                {children}
            </div>
        </Transition>,
        target.value,
    );
};

export default Popup;
